import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-dashboard-leader',
  templateUrl: './dashboard-leader.component.html',
  styleUrls: [
    './dashboard-leader.component.scss',
    '../../../../styles/_dropdown.scss',
  ],
  imports: [
    MatButtonModule,
    MatDialogModule,
    MatSelectModule,
    MatIconModule,
    CommonModule,
  ],
})
export class DashboardLeaderComponent implements OnInit {
  public colData: any = [
    'Mem Key',
    'Full Name',
    'Guardian’s Name',
    'Ritwik’s Name',
    'Address',
    'PIN Code',
    'District',
    'State',
    'Contact',
  ];

  adminData: any = [];
  selectOptions = [
    {
      label: 'One',
      value:1,
    },
    {
      label: 'Two',
      value:2,
    },
    {
      label: 'Three',
      value:3,
    },
  ]

  constructor(public dialog: MatDialog) {}

  ngOnInit(): void {
      this.adminData= [
        {
          username:'Virat',
          location: 'New Delhi, Delhi',
          points: '200',
        },
        {
          username:'Virat',
          location: 'New Delhi, Delhi',
          points: '200',
        },
        {
          username:'Virat',
          location: 'New Delhi, Delhi',
          points: '200',
        },
        {
          username:'Virat',
          location: 'New Delhi, Delhi',
          points: '200',
        },
      ]
  }

  onOptionSelected(event: Event) {
    const selectElement = event.target as HTMLSelectElement;
    const selectedValue = selectElement.value;

    switch (selectedValue) {
      case 'option1':
        this.handleOption1();
        break;
      case 'option2':
        this.handleOption2();
        break;
      case 'option3':
        this.handleOption3();
        break;
    }
  }
  handleOption3() {
    throw new Error('Method not implemented.');
  }
  handleOption2() {
    throw new Error('Method not implemented.');
  }
  handleOption1() {
    throw new Error('Method not implemented.');
  }

  onClickFullTable(){
    // this.dialog.open(,{
    //   width: '97vw',
    //   maxWidth: '100vw',
    //   height: 'calc(100vh - 80px)',
    //   panelClass: 'common-pannel-dialog-container',
    //   data: {

    //   },
    // });
  }

}
